import { FixMe } from '@utils/types';
import React from 'react';
import { LineCountWrapper } from './styles';

interface LineNumberProps {
  jsonData: { [i: string]: FixMe }[];
}

const calculateRowCount = (json: FixMe) =>
  Object.keys(json).reduce((accum, key) => {
    const currentValue = json[key];
    if (currentValue && typeof currentValue === 'object') {
      accum += calculateRowCount(currentValue);
    } else {
      accum += 1;
    }
    return accum;
  }, 2);

const calculateRowCountArray = (array: FixMe[]) =>
  array.reduce((accum, json) => {
    accum += calculateRowCount(json);
    return accum;
  }, 0);

const LineNumbers = ({ jsonData }: LineNumberProps) => {
  const totalNumbers = calculateRowCountArray(jsonData);
  return (
    <LineCountWrapper>
      {Array.from({ length: totalNumbers }).map((_, i) => (
        <div>{i + 1}</div>
      ))}
    </LineCountWrapper>
  );
};

export default LineNumbers;
